module.exports = __webpack_public_path__ + "img/restaurant-4.14131ed9.jpg";